export default {"src":"/_next/static/media/PDF-ANN.a1a3ec81.svg","height":27,"width":22};